export default "__VITE_ASSET__3750090f__"